module.exports = __webpack_public_path__ + "static/media/catalogueImg4.b6ca1e45.png";